import React from 'react';
import { Snowflake, ArrowRight, Flame } from 'lucide-react';
export function WinterCombosBanner() {
  const scrollToCombos = (e: React.MouseEvent) => {
    e.preventDefault();
    const section = document.getElementById('combos');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-gradient-to-br from-[#1a1100] via-[#2a1a00] to-[#1a1100] py-12 md:py-16 px-5 overflow-hidden border-y-[3px] border-alphaGold shadow-[0_0_60px_rgba(212,160,23,0.15)_inset]" data-id="element-406">
      {/* Decorative snowflakes */}
      <Snowflake className="absolute top-6 left-[10%] w-6 h-6 text-alphaGold/20 hidden md:block animate-pulse" data-id="element-407" />
      <Snowflake className="absolute bottom-8 right-[15%] w-8 h-8 text-alphaGold/15 hidden md:block animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-408" />
      <Snowflake className="absolute top-1/2 right-[8%] w-5 h-5 text-alphaGold/20 hidden lg:block animate-pulse" style={{
      animationDelay: '2s'
    }} data-id="element-409" />

      {/* Radial glow effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,160,23,0.25)_0%,transparent_60%)] pointer-events-none" data-id="element-410" />

      {/* Diagonal accent stripe */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-alphaGold to-transparent" data-id="element-411" />
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-alphaGold to-transparent" data-id="element-412" />

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-413">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-414">
          {/* Image */}
          <div className="relative order-2 md:order-1" data-id="element-415">
            <div className="relative rounded-2xl overflow-hidden border-2 border-alphaGold/40 shadow-[0_10px_40px_rgba(212,160,23,0.25)] aspect-[4/3] md:aspect-[5/4]" data-id="element-416">
              <img src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=800&q=80" alt="Suplementos invernales AlphaFit" className="w-full h-full object-cover" data-id="element-417" />
              {/* Overlay with frosty tint */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-transparent to-alphaGold/20" data-id="element-418" />

              {/* Floating badge on image */}
              <div className="absolute top-4 left-4 bg-alphaGold text-dark-900 px-4 py-2 rounded-full font-black text-xs md:text-sm uppercase tracking-wider shadow-lg flex items-center gap-1.5" data-id="element-419">
                <Flame className="w-4 h-4" data-id="element-420" />
                Edición Invierno
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2 text-center md:text-left" data-id="element-421">
            <div className="inline-flex items-center gap-2 bg-alphaGold/10 border border-alphaGold/40 text-alphaGold px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-[2px] mb-4" data-id="element-422">
              <Snowflake className="w-4 h-4" data-id="element-423" />
              Combos de Invierno
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white uppercase leading-tight tracking-tight mb-4" data-id="element-424">
              El frío no{' '}
              <span className="text-alphaGold" data-id="element-425">frena tus resultados</span>
            </h2>

            <p className="text-[#ccc] text-base md:text-lg leading-relaxed mb-6 max-w-xl mx-auto md:mx-0" data-id="element-426">
              Aprovechá nuestros{' '}
              <strong className="text-white" data-id="element-427">
                combos invernales exclusivos
              </strong>{' '}
              con descuentos imperdibles. Suplementos premium combinados para
              que sigas ganando masa, fuerza y energía todo el invierno — al
              mejor precio del año.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 mb-6 justify-center md:justify-start" data-id="element-428">
              <div className="flex items-center gap-2 text-sm text-[#aaa]" data-id="element-429">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-430"></span>
                <span className="font-semibold" data-id="element-431">Stock limitado</span>
              </div>
              <span className="hidden sm:inline text-[#555]" data-id="element-432">·</span>
              <div className="text-sm text-[#aaa] font-semibold" data-id="element-433">
                Ahorrá hasta{' '}
                <span className="text-alphaGold font-black" data-id="element-434">$1.200</span>
              </div>
            </div>

            <a href="#combos" onClick={scrollToCombos} className="group inline-flex items-center gap-3 bg-alphaGold hover:bg-alphaGoldDark text-dark-900 font-black uppercase tracking-wider text-sm md:text-base py-4 px-7 md:px-9 rounded-lg shadow-[0_8px_25px_rgba(212,160,23,0.4)] hover:shadow-[0_10px_35px_rgba(212,160,23,0.6)] transition-all duration-300 hover:-translate-y-1" data-id="element-435">
              Ver Combos Invernales
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-436" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}